<template>
  <div class="carousel-section">
    <div class="carousel-container">
      <div class="carousel-hero">
        <div v-for="item in banners" :key="item.id" class="hero-slide">
          <!-- 背景圖片（真實 img 元素，object-fit: cover） -->
          <img class="slide-bg-img" :src="item.img_url" :alt="item.title" />

          <!-- 遮罩層 -->
          <div class="slide-overlay"></div>

          <!-- 內容 -->
          <div class="hero-content">
            <h1 class="hero-title">{{ item.title }}</h1>
            <p class="hero-subtitle">{{ item.subtitle }}</p>
            <router-link :to="item.linkTo" class="hero-btn">
              前往了解 {{ item.title }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

// 靜態 mockup data
const banners = ref([
  {
    id: 1,
    img_url: "/banner.webp",
    title: "RxNorm",
    subtitle: `統一藥物資料編碼標準
支持用藥安全與臨床決策應用`,
    linkTo: "/rxnorm/intro",
  },
]);
</script>

<style scoped>
.carousel-section {
  padding-top: 60px;
  /* 導覽列高度補償 */
  background-color: #000;
}

.carousel-container {
  margin: 0 auto;
  width: 100%;
}

.carousel-hero {
  width: 100%;
  position: relative;
}

/* 滿版螢幕高度（扣除 navbar 60px） */
.hero-slide {
  width: 100%;
  height: calc(100vh - 60px);
  min-height: 480px;
  background-color: #066360;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

/* 背景圖：真實 img + object-fit: cover */
.slide-bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 40%;
  z-index: 1;
  display: block;
}

/* 遮罩層：多層漸層 */
.slide-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0) 38.33%, rgba(6, 99, 96, 0.9) 97.79%),
    linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
}

/* 文字內容區：電腦版靠下置中 */
.hero-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 32px 80px;
  position: relative;
  z-index: 3;
  height: 100%;
  text-align: left;
  gap: 24px;
}

/* 標題 */
.hero-title {
  font-family: "Noto Sans TC", sans-serif;
  font-weight: 700;
  font-size: 56px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #ffffff;
  margin: 0;
  text-shadow: none;
}

/* 簡短網站介紹 */
.hero-subtitle {
  font-family: "Noto Sans TC", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
  white-space: pre-line;
  letter-spacing: 0%;
  color: #ffffff;
  margin: 0;
  text-shadow: none;
}

/* CTA 按鈕 */
.hero-btn {
  display: inline-block;
  padding: 8px 32px;
  gap: 10px;
  border-radius: 100px;
  background: var(--Background-White, #ffffff);
  color: #066360;
  font-family: "Noto Sans TC", sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
  white-space: nowrap;
}

.hero-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* ===== 響應式設計（手機版） ===== */
@media (max-width: 768px) {
  .slide-bg-img {
    object-position: right;
  }

  .carousel-section {
    padding-top: 56px;
    /* 手機版 navbar 高度 */
  }

  .hero-slide {
    height: calc(100vh - 56px);
    min-height: 360px;
  }

  .hero-content {
    padding: 0 24px 48px;
    gap: 16px;
  }

  .hero-title {
    font-size: 36px;
    line-height: 110%;
  }

  .hero-subtitle {
    font-size: 18px;
    line-height: 140%;
  }

  .hero-btn {
    font-size: 16px;
    padding: 8px 24px;
    line-height: 28px;
  }
}

/* ===== 小尺寸手機 ===== */
@media (max-width: 400px) {
  .hero-content {
    padding: 0 20px 40px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .hero-btn {
    font-size: 14px;
    padding: 8px 20px;
  }
}
</style>
